/*
 * @Author: v-fmasoud@tableau.com
 * @Date: 2017-10-10 11:23:11
 * @Last Modified by: fmasoud@tableau.com
 * @Last Modified time: 2018-06-28 13:42:11
 */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpBackend from 'i18next-http-backend';

export const supportedLocales = [
  'de-DE', 'en-US', 'en-GB', 'fr-FR', 'fr-CA', 'ja-JP',
  'zh-CN', 'zh-TW', 'sv-SE', 'th-TH', 'ko-KR', 'pt-BR',
  'es-ES', 'it-IT', 'nl-NL',
];

export const normalizeLangCode = (lang) => {
  if (!lang) return 'en-US';
  const langLower = lang.toLowerCase();

  for (let i = 0; i < supportedLocales.length; i += 1) {
    if (langLower === supportedLocales[i].toLowerCase()) {
      return supportedLocales[i];
    }
  }

  if (langLower.includes('en-gb')) return 'en-GB';
  if (langLower.includes('zh-tw') || langLower.includes('zh-hant')) return 'zh-TW';
  if (langLower.includes('zh-cn') || langLower.includes('zh-hans') || langLower === 'zh') return 'zh-CN';
  if (langLower.includes('fr-ca')) return 'fr-CA';
  if (langLower.includes('ko')) return 'ko-KR';
  if (langLower.includes('ja')) return 'ja-JP';
  if (langLower.includes('de')) return 'de-DE';
  if (langLower.includes('fr')) return 'fr-FR';
  if (langLower.includes('es')) return 'es-ES';
  if (langLower.includes('it')) return 'it-IT';
  if (langLower.includes('nl')) return 'nl-NL';
  if (langLower.includes('pt')) return 'pt-BR';
  if (langLower.includes('sv')) return 'sv-SE';
  if (langLower.includes('th')) return 'th-TH';
  if (langLower.includes('en')) return 'en-US';

  return 'en-US';
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : null;
};

export const getInitialLanguage = () => {
  try {
    const urlLang = new URLSearchParams(window.location.search).get('lng');
    const cookieLang = getCookie('tableauLang');
    const navigatorLang = navigator.language || navigator.userLanguage;
    return normalizeLangCode(urlLang || cookieLang || navigatorLang);
  } catch (error) {
    return 'en-US';
  }
};

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  // Stores translation files in local storage.
  // Options below to contorl caching behavior.
  .use(Backend)
  .init({
    debug: false,
    lng: getInitialLanguage(),
    load: 'currentOnly',
    supportedLngs: supportedLocales,
    nsSeparator: false,
    keySeparator: false,
    fallbackLng: "en-US",
    returnEmptyString: false, // Consider empty string values as invalid translations.
    returnNull: false,
    lowerCaseLng: false,
    // Disable trying to load locale specific files since we only have the base languages.
    // If in the future there are locale specific files, remove this option.
    backend: {
      backends: [
        LocalStorageBackend, // primary
        HttpBackend, // fallback
      ],
      backendOptions: [
        {
          // prefix for stored languages
          prefix: 'i18next_res_',
          expirationTime: 365 * 24 * 60 * 60 * 1000, // 1 year
          versions: {
            'de-DE': 'v3.6',
            'en-US': 'v3.6',
            'en-GB': 'v3.6',
            'fr-FR': 'v3.6',
            'fr-CA': 'v3.6',
            'ja-JP': 'v3.6',
            'zh-CN': 'v3.6',
            'zh-TW': 'v3.6',
            'sv-SE': 'v3.6',
            'th-th': 'v3.6',
            'ko-KR': 'v3.6',
            'pt-BR': 'v3.6',
            'es-ES': 'v3.6',
            'it-IT': 'v3.6',
            'nl-NL': 'v3.6',
          },
        },
        {
          loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`, // http-backend load path for the fallback
          addPath: null,
          saveMissing: false,
        },
      ],
    },
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    react: {
      wait: true,
    },
    detection: {
      // Settings for language detector
      order: ['querystring', 'cookie', 'navigator'],
      lookupQuerystring: 'lng',
      lookupCookie: 'tableauLang',
      caches: ['cookie'],
      cookieMinutes: 525600, // one year
      cookieDomain: window.REACT_APP_LANGUAGE_COOKIE_DOMAIN,
    },
    saveMissing: false,
  });

export default i18n;
